// import React, { useEffect, useState } from 'react'
// import { Calendar, List, Clock, Search, X, DollarSign } from 'lucide-react'
// import * as api from '../../../app/axios/api.jsx'

// const Fee = () => {
//   // आज की तारीख प्राप्त करने के लिए Helper फ़ंक्शन (YYYY-MM-DD फॉर्मेट)
//   const getTodayDateString = () => {
//     const today = new Date()
//     const offset = today.getTimezoneOffset()
//     const localToday = new Date(today.getTime() - offset * 60 * 1000)
//     return localToday.toISOString().split('T')[0]
//   }

//   const currentDate = new Date()
//   const currentMonth = currentDate.getMonth() + 1
//   const currentYear = currentDate.getFullYear()

//   const [month, setMonth] = useState(currentMonth)
//   const [year, setYear] = useState(currentYear)
//   const [fees, setFees] = useState([])
//   const [currentPage, setCurrentPage] = useState(1)
//   const [showCalendar, setShowCalendar] = useState(false)

//   // खोज और फ़िल्टर स्टेट्स
//   const [searchTerm, setSearchTerm] = useState('')
//   const [filterCourse, setFilterCourse] = useState('')

//   // 1. Status डिफ़ॉल्ट रूप से 'All' (खाली स्ट्रिंग '') रखने के लिए बदलाव
//   const [filterStatus, setFilterStatus] = useState('')

//   // 2. Single Date की जगह Start Date और End Date स्टेट्स (डिफ़ॉल्ट आज की तारीख)
//   const [startDate, setStartDate] = useState(getTodayDateString())
//   const [endDate, setEndDate] = useState(getTodayDateString())

//   const [itemsPerPage, setItemsPerPage] = useState(25)

//   // API से सभी फीस डेटा प्राप्त करना
//   const fetchFees = async () => {
//     try {
//       const response = await api.getAllFeeList()
//       setFees(response.data || [])
//     } catch (error) {
//       console.error('Error fetching fees:', error)
//       setFees([])
//     }
//   }

//   const fetchFeesDaysWiseList = async (month, year) => {
//     try {
//       const response = await api.fetchFeesDaysWise(month, year)
//       setFees(response.data || [])
//     } catch (error) {
//       console.error('Error fetching fees for date:', error)
//       setFees([])
//     }
//   }

//   // शुरुआती रेंडर पर डेटा लोड करना
//   useEffect(() => {
//     fetchFees()
//   }, [])

//   // Today बटन क्लिक हैंडलर - तारीखों को आज पर रीसेट करने के लिए
//   const handleTodayClick = () => {
//     const todayStr = getTodayDateString()
//     setStartDate(todayStr)
//     setEndDate(todayStr)
//     setCurrentPage(1)
//   }

//   const formatDate = (dateString) => {
//     const date = new Date(dateString)
//     return date.toLocaleDateString('en-IN')
//   }

//   // सभी फ़िल्टर रीसेट करना
//   const handleResetFilters = () => {
//     setSearchTerm('')
//     setFilterCourse('')
//     setFilterStatus('')
//     setStartDate('')
//     setEndDate('')
//     setCurrentPage(1)
//   }

//   // फ़िल्टर और खोज लॉजिक (Start Date और End Date शामिल)
//   const filteredFees = fees.filter((fee) => {
//     const matchesSearch =
//       (fee.name && fee.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
//       (fee.course &&
//         fee.course.toLowerCase().includes(searchTerm.toLowerCase()))

//     const matchesCourse =
//       filterCourse === '' || (fee.course && fee.course === filterCourse)

//     const matchesStatus =
//       filterStatus === '' || (fee.status && fee.status === filterStatus)

//     // Start Date और End Date के बीच की रेंज फ़िल्टर करना
//     let matchesDate = true
//     const targetDateStr =
//       fee.fee_submit_date && fee.fee_submit_date !== '0001-01-01'
//         ? fee.fee_submit_date
//         : fee.created_at

//     if (targetDateStr) {
//       const feeDate = new Date(targetDateStr).toISOString().split('T')[0]
//       if (startDate && endDate) {
//         matchesDate = feeDate >= startDate && feeDate <= endDate
//       } else if (startDate) {
//         matchesDate = feeDate >= startDate
//       } else if (endDate) {
//         matchesDate = feeDate <= endDate
//       }
//     } else {
//       if (startDate || endDate) {
//         matchesDate = false
//       }
//     }

//     return matchesSearch && matchesCourse && matchesStatus && matchesDate
//   })

//   // 3. फ़िल्टर किए गए रिकॉर्ड्स के आधार पर Total Paid Fee की गणना
//   const totalPaidFee = filteredFees.reduce((sum, fee) => {
//     const amount = parseFloat(fee.amount) || 0
//     return sum + amount
//   }, 0)

//   const uniqueCourses = [
//     ...new Set(fees.map((fee) => fee.course).filter(Boolean)),
//   ].filter((course) => course)

//   const totalPages = Math.ceil(filteredFees.length / itemsPerPage)
//   const startIndex = (currentPage - 1) * itemsPerPage
//   const endIndex = startIndex + itemsPerPage
//   const currentFees = filteredFees.slice(startIndex, endIndex)

//   return (
//     <div className='min-h-screen bg-gray-50 p-4 md:p-6'>
//       {/* Header */}
//       <div className='bg-white rounded-lg shadow-sm p-4 mb-6'>
//         <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4'>
//           <h1 className='text-2xl font-bold text-gray-800'>Fee Management</h1>

//           <div className='flex flex-wrap gap-3'>
//             <button
//               onClick={() => fetchFees()}
//               className='flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition'
//             >
//               <List size={18} />
//               <span>All Fee List</span>
//             </button>

//             <button
//               onClick={handleTodayClick}
//               className='flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition'
//             >
//               <Clock size={18} />
//               <span>Today</span>
//             </button>

//             <div className='relative'>
//               <button
//                 onClick={() => setShowCalendar(!showCalendar)}
//                 className='flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition'
//               >
//                 <Calendar size={18} />
//                 <span>{`${month}/${year}`}</span>
//               </button>

//               {showCalendar && (
//                 <div className='absolute right-0 mt-2 bg-white rounded-lg shadow-lg p-4 z-10 border'>
//                   <div className='flex gap-2 mb-2'>
//                     <select
//                       value={month}
//                       onChange={(e) => setMonth(Number(e.target.value))}
//                       className='px-3 py-2 border rounded-lg'
//                     >
//                       {[...Array(12)].map((_, i) => (
//                         <option key={i + 1} value={i + 1}>
//                           {new Date(2000, i).toLocaleString('default', {
//                             month: 'long',
//                           })}
//                         </option>
//                       ))}
//                     </select>

//                     <select
//                       value={year}
//                       onChange={(e) => setYear(Number(e.target.value))}
//                       className='px-3 py-2 border rounded-lg'
//                     >
//                       {[...Array(10)].map((_, i) => (
//                         <option
//                           key={currentYear - 5 + i}
//                           value={currentYear - 5 + i}
//                         >
//                           {currentYear - 5 + i}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <button
//                     onClick={() => {
//                       fetchFeesDaysWiseList(month, year)
//                       setShowCalendar(false)
//                       setCurrentPage(1)
//                     }}
//                     className='w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700'
//                   >
//                     Apply
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Search and Filter Section */}
//       <div className='bg-white rounded-lg shadow-sm p-4 mb-6'>
//         <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4'>
//           {/* Search */}
//           <div className='lg:col-span-2'>
//             <label className='block text-sm font-medium text-gray-700 mb-2'>
//               Search
//             </label>
//             <div className='flex flex-col sm:flex-row items-start sm:items-center gap-3'>
//               <div className='relative w-full sm:flex-1'>
//                 <Search
//                   className='absolute left-3 top-1/2 -translate-y-1/2 text-gray-400'
//                   size={18}
//                 />
//                 <input
//                   type='text'
//                   placeholder='Search by name or course...'
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value)
//                     setCurrentPage(1)
//                   }}
//                   className='w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
//                 />
//               </div>

//               <div className='w-full sm:w-28'>
//                 <select
//                   value={itemsPerPage}
//                   onChange={(e) => {
//                     setItemsPerPage(Number(e.target.value))
//                     setCurrentPage(1)
//                   }}
//                   className='w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
//                 >
//                   {[25, 50, 100, 150, 200, 300, 400].map((n) => (
//                     <option key={n} value={n}>
//                       {n}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           </div>

//           {/* Course Filter */}
//           <div>
//             <label className='block text-sm font-medium text-gray-700 mb-2'>
//               Course
//             </label>
//             <select
//               value={filterCourse}
//               onChange={(e) => {
//                 setFilterCourse(e.target.value)
//                 setCurrentPage(1)
//               }}
//               className='w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
//             >
//               <option value=''>All Courses</option>
//               {uniqueCourses.map((course) => (
//                 <option key={course} value={course}>
//                   {course}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Status Filter */}
//           <div>
//             <label className='block text-sm font-medium text-gray-700 mb-2'>
//               Status
//             </label>
//             <select
//               value={filterStatus}
//               onChange={(e) => {
//                 setFilterStatus(e.target.value)
//                 setCurrentPage(1)
//               }}
//               className='w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
//             >
//               <option value=''>All Status</option>
//               <option value='running'>Running</option>
//               <option value='completed'>Completed</option>
//               <option value='pending'>Pending</option>
//             </select>
//           </div>

//           {/* Start Date Filter */}
//           <div>
//             <label className='block text-sm font-medium text-gray-700 mb-2'>
//               Start Date
//             </label>
//             <input
//               type='date'
//               value={startDate}
//               onChange={(e) => {
//                 setStartDate(e.target.value)
//                 setCurrentPage(1)
//               }}
//               className='w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
//             />
//           </div>

//           {/* End Date Filter */}
//           <div>
//             <label className='block text-sm font-medium text-gray-700 mb-2'>
//               End Date
//             </label>
//             <input
//               type='date'
//               value={endDate}
//               onChange={(e) => {
//                 setEndDate(e.target.value)
//                 setCurrentPage(1)
//               }}
//               className='w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
//             />
//           </div>
//         </div>

//         {/* Active Filters & Reset */}
//         {(searchTerm ||
//           filterCourse ||
//           filterStatus !== '' ||
//           startDate ||
//           endDate) && (
//           <div className='mt-4 flex flex-wrap items-center gap-2'>
//             <span className='text-sm font-medium text-gray-700'>
//               Active Filters:
//             </span>

//             {searchTerm && (
//               <span className='inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm'>
//                 Search: {searchTerm}
//                 <X
//                   size={14}
//                   className='cursor-pointer'
//                   onClick={() => setSearchTerm('')}
//                 />
//               </span>
//             )}

//             {filterCourse && (
//               <span className='inline-flex items-center gap-1 px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm'>
//                 Course: {filterCourse}
//                 <X
//                   size={14}
//                   className='cursor-pointer'
//                   onClick={() => setFilterCourse('')}
//                 />
//               </span>
//             )}

//             {filterStatus && (
//               <span className='inline-flex items-center gap-1 px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm'>
//                 Status: {filterStatus}
//                 <X
//                   size={14}
//                   className='cursor-pointer'
//                   onClick={() => setFilterStatus('')}
//                 />
//               </span>
//             )}

//             {startDate && (
//               <span className='inline-flex items-center gap-1 px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm'>
//                 From: {startDate}
//                 <X
//                   size={14}
//                   className='cursor-pointer'
//                   onClick={() => setStartDate('')}
//                 />
//               </span>
//             )}

//             {endDate && (
//               <span className='inline-flex items-center gap-1 px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm'>
//                 To: {endDate}
//                 <X
//                   size={14}
//                   className='cursor-pointer'
//                   onClick={() => setEndDate('')}
//                 />
//               </span>
//             )}

//             <button
//               onClick={handleResetFilters}
//               className='ml-2 px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm hover:bg-red-200 transition'
//             >
//               Reset All
//             </button>
//           </div>
//         )}

//         {/* Results Count */}
//         <div className='mt-4 text-sm text-gray-600'>
//           Showing {filteredFees.length} of {fees.length} total records
//         </div>
//       </div>

//       {/* Fee Cards */}
//       <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6'>
//         {currentFees.map((fee) => (
//           <div
//             key={fee.id}
//             className='bg-white rounded-lg shadow-sm p-5 hover:shadow-md transition'
//           >
//             <div className='flex justify-between items-start mb-3'>
//               <div>
//                 <h3 className='text-lg font-semibold text-gray-800'>
//                   {fee.name}
//                 </h3>
//                 <p className='text-sm text-gray-500'>{fee.enrollment_number}</p>
//               </div>
//               <span
//                 className={`px-3 py-1 rounded-full text-xs font-medium ${
//                   fee.status === 'running'
//                     ? 'bg-green-100 text-green-700'
//                     : 'bg-gray-100 text-gray-700'
//                 }`}
//               >
//                 {fee.status}
//               </span>
//             </div>

//             <div className='space-y-2 mb-3'>
//               <div className='flex justify-between text-sm'>
//                 <span className='text-gray-600'>Course:</span>
//                 <span className='font-medium'>{fee.course}</span>
//               </div>
//               <div className='flex justify-between text-sm'>
//                 <span className='text-gray-600'>Class:</span>
//                 <span className='font-medium'>{fee.class}</span>
//               </div>
//               <div className='flex justify-between text-sm'>
//                 <span className='text-gray-600'>Total Fee:</span>
//                 <span className='font-medium'>₹{fee.total_fee}</span>
//               </div>
//               <div className='flex justify-between text-sm'>
//                 <span className='text-gray-600'>Amount Paid:</span>
//                 <span className='font-medium text-green-600'>
//                   ₹{fee.amount}
//                 </span>
//               </div>
//               <div className='flex justify-between text-sm'>
//                 <span className='text-gray-600'>Due Fee:</span>
//                 <span className='font-medium text-red-600'>₹{fee.due_fee}</span>
//               </div>
//             </div>

//             <div className='border-t pt-3 space-y-1'>
//               <div className='flex justify-between text-xs text-gray-500'>
//                 <span>Submit Date:</span>
//                 <span>
//                   {fee.fee_submit_date && fee.fee_submit_date !== '0001-01-01'
//                     ? formatDate(fee.fee_submit_date)
//                     : 'N/A'}
//                 </span>
//               </div>
//               <div className='flex justify-between text-xs text-gray-500'>
//                 <span>Payment Mode:</span>
//                 <span>{fee.payment_mode}</span>
//               </div>
//               <div className='flex justify-between text-xs text-gray-500'>
//                 <span>Receipt ID:</span>
//                 <span>{fee.receipt_id}</span>
//               </div>
//               <div className='flex justify-between text-xs text-gray-500'>
//                 <span>Phone:</span>
//                 <span>{fee.phone_number}</span>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className='bg-white rounded-lg shadow-sm p-4'>
//           <div className='flex flex-col sm:flex-row justify-between items-center gap-4'>
//             <div className='flex items-center gap-3'>
//               <p className='text-sm text-gray-600'>
//                 Showing {startIndex + 1} to{' '}
//                 {Math.min(endIndex, filteredFees.length)} of{' '}
//                 {filteredFees.length} entries
//               </p>

//               <div className='flex items-center gap-2'>
//                 <label className='text-sm text-gray-600'>Show:</label>
//                 <select
//                   value={itemsPerPage}
//                   onChange={(e) => {
//                     setItemsPerPage(Number(e.target.value))
//                     setCurrentPage(1)
//                   }}
//                   className='px-3 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
//                 >
//                   <option value={25}>25</option>
//                   <option value={50}>50</option>
//                   <option value={100}>100</option>
//                   <option value={150}>150</option>
//                   <option value={200}>200</option>
//                   <option value={300}>300</option>
//                   <option value={400}>400</option>
//                 </select>
//               </div>
//             </div>

//             <div className='flex gap-2'>
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1}
//                 className='px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed'
//               >
//                 Previous
//               </button>

//               <div className='flex gap-1'>
//                 {[...Array(totalPages)].map((_, i) => {
//                   const pageNum = i + 1
//                   if (
//                     pageNum === 1 ||
//                     pageNum === totalPages ||
//                     (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
//                   ) {
//                     return (
//                       <button
//                         key={pageNum}
//                         onClick={() => setCurrentPage(pageNum)}
//                         className={`px-3 py-2 rounded-lg ${
//                           currentPage === pageNum
//                             ? 'bg-blue-600 text-white'
//                             : 'border hover:bg-gray-50'
//                         }`}
//                       >
//                         {pageNum}
//                       </button>
//                     )
//                   } else if (
//                     pageNum === currentPage - 2 ||
//                     pageNum === currentPage + 2
//                   ) {
//                     return (
//                       <span key={pageNum} className='px-2 py-2'>
//                         ...
//                       </span>
//                     )
//                   }
//                   return null
//                 })}
//               </div>

//               <button
//                 onClick={() =>
//                   setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                 }
//                 disabled={currentPage === totalPages}
//                 className='px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed'
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {filteredFees.length === 0 && (
//         <div className='bg-white rounded-lg shadow-sm p-8 text-center'>
//           <p className='text-gray-500'>
//             No fee records found for the selected criteria
//           </p>
//         </div>
//       )}
//     </div>
//   )
// }

// export default Fee
import React, { useEffect, useState } from 'react'
import { Calendar, List, Clock, Search, X, DollarSign } from 'lucide-react'
import * as api from '../../../app/axios/api.jsx'

const Fee = () => {
  // आज की तारीख प्राप्त करने के लिए Helper फ़ंक्शन (YYYY-MM-DD फॉर्मेट)
  const getTodayDateString = () => {
    const today = new Date()
    const offset = today.getTimezoneOffset()
    const localToday = new Date(today.getTime() - offset * 60 * 1000)
    return localToday.toISOString().split('T')[0]
  }

  const currentDate = new Date()
  const currentMonth = currentDate.getMonth() + 1
  const currentYear = currentDate.getFullYear()

  const [month, setMonth] = useState(currentMonth)
  const [year, setYear] = useState(currentYear)
  const [fees, setFees] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [showCalendar, setShowCalendar] = useState(false)

  // खोज और फ़िल्टर स्टेट्स
  const [searchTerm, setSearchTerm] = useState('')
  const [filterCourse, setFilterCourse] = useState('')

  // Status डिफ़ॉल्ट रूप से 'All' (खाली स्ट्रिंग '') रखने के लिए बदलाव
  const [filterStatus, setFilterStatus] = useState('')

  // Start Date और End Date स्टेट्स (डिफ़ॉल्ट आज की तारीख)
  const [startDate, setStartDate] = useState(getTodayDateString())
  const [endDate, setEndDate] = useState(getTodayDateString())

  const [itemsPerPage, setItemsPerPage] = useState(25)

  // API से फ़ीस डेटा प्राप्त करना (Date Parameters के साथ)
  const fetchFees = async (toVal = endDate, fromVal = startDate) => {
    try {
      const response = await api.getAllFeeList(toVal, fromVal)
      setFees(response.data || [])
    } catch (error) {
      console.error('Error fetching fees:', error)
      setFees([])
    }
  }

  const fetchFeesDaysWiseList = async (month, year) => {
    try {
      const response = await api.fetchFeesDaysWise(month, year)
      setFees(response.data || [])
    } catch (error) {
      console.error('Error fetching fees for date:', error)
      setFees([])
    }
  }

  // जब भी Start Date या End Date बदले, तब API दोबारा कॉल हो
  useEffect(() => {
    fetchFees(endDate, startDate)
  }, [startDate, endDate])

  // Today बटन क्लिक हैंडलर - तारीखों को आज पर रीसेट करने के लिए
  const handleTodayClick = () => {
    const todayStr = getTodayDateString()
    setStartDate(todayStr)
    setEndDate(todayStr)
    setCurrentPage(1)
  }

  // सभी फ़ीस सूची देखने के लिए (तारीख हटाकर API से सारा डेटा मंगाने के लिए)
  const handleAllFeeListClick = () => {
    setStartDate('')
    setEndDate('')
    setCurrentPage(1)
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-IN')
  }

  // सभी फ़िल्टर रीसेट करना
  const handleResetFilters = () => {
    setSearchTerm('')
    setFilterCourse('')
    setFilterStatus('')
    setStartDate('')
    setEndDate('')
    setCurrentPage(1)
  }

  // फ़िल्टर और खोज लॉजिक (तारीख का फ़िल्टर अब API से हो रहा है)
  const filteredFees = fees.filter((fee) => {
    const matchesSearch =
      (fee.name && fee.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (fee.course &&
        fee.course.toLowerCase().includes(searchTerm.toLowerCase()))

    const matchesCourse =
      filterCourse === '' || (fee.course && fee.course === filterCourse)

    const matchesStatus =
      filterStatus === '' || (fee.status && fee.status === filterStatus)

    return matchesSearch && matchesCourse && matchesStatus
  })

  // फ़िल्टर किए गए रिकॉर्ड्स के आधार पर Total Paid Fee की गणना
  const totalPaidFee = filteredFees.reduce((sum, fee) => {
    const amount = parseFloat(fee.amount) || 0
    return sum + amount
  }, 0)

  const uniqueCourses = [
    ...new Set(fees.map((fee) => fee.course).filter(Boolean)),
  ].filter((course) => course)

  const totalPages = Math.ceil(filteredFees.length / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const currentFees = filteredFees.slice(startIndex, endIndex)

  return (
    <div className='min-h-screen bg-gray-50 p-4 md:p-6'>
      {/* Header */}
      <div className='bg-white rounded-lg shadow-sm p-4 mb-6'>
        <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4'>
          <h1 className='text-2xl font-bold text-gray-800'>Fee Management</h1>

          <div className='flex flex-wrap gap-3'>
            <button
              onClick={handleAllFeeListClick}
              className='flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition'
            >
              <List size={18} />
              <span>All Fee List</span>
            </button>

            <button
              onClick={handleTodayClick}
              className='flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition'
            >
              <Clock size={18} />
              <span>Today</span>
            </button>

            <div className='relative'>
              <button
                onClick={() => setShowCalendar(!showCalendar)}
                className='flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition'
              >
                <Calendar size={18} />
                <span>{`${month}/${year}`}</span>
              </button>

              {showCalendar && (
                <div className='absolute right-0 mt-2 bg-white rounded-lg shadow-lg p-4 z-10 border'>
                  <div className='flex gap-2 mb-2'>
                    <select
                      value={month}
                      onChange={(e) => setMonth(Number(e.target.value))}
                      className='px-3 py-2 border rounded-lg'
                    >
                      {[...Array(12)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {new Date(2000, i).toLocaleString('default', {
                            month: 'long',
                          })}
                        </option>
                      ))}
                    </select>

                    <select
                      value={year}
                      onChange={(e) => setYear(Number(e.target.value))}
                      className='px-3 py-2 border rounded-lg'
                    >
                      {[...Array(10)].map((_, i) => (
                        <option
                          key={currentYear - 5 + i}
                          value={currentYear - 5 + i}
                        >
                          {currentYear - 5 + i}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button
                    onClick={() => {
                      fetchFeesDaysWiseList(month, year)
                      setShowCalendar(false)
                      setCurrentPage(1)
                    }}
                    className='w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700'
                  >
                    Apply
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Search and Filter Section */}
      <div className='bg-white rounded-lg shadow-sm p-4 mb-6'>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4'>
          {/* Search */}
          <div className='lg:col-span-2'>
            <label className='block text-sm font-medium text-gray-700 mb-2'>
              Search
            </label>
            <div className='flex flex-col sm:flex-row items-start sm:items-center gap-3'>
              <div className='relative w-full sm:flex-1'>
                <Search
                  className='absolute left-3 top-1/2 -translate-y-1/2 text-gray-400'
                  size={18}
                />
                <input
                  type='text'
                  placeholder='Search by name or course...'
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value)
                    setCurrentPage(1)
                  }}
                  className='w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                />
              </div>

              <div className='w-full sm:w-28'>
                <select
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value))
                    setCurrentPage(1)
                  }}
                  className='w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                >
                  {[25, 50, 100, 150, 200, 300, 400].map((n) => (
                    <option key={n} value={n}>
                      {n}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Course Filter */}
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>
              Course
            </label>
            <select
              value={filterCourse}
              onChange={(e) => {
                setFilterCourse(e.target.value)
                setCurrentPage(1)
              }}
              className='w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
            >
              <option value=''>All Courses</option>
              {uniqueCourses.map((course) => (
                <option key={course} value={course}>
                  {course}
                </option>
              ))}
            </select>
          </div>

          {/* Status Filter */}
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>
              Status
            </label>
            <select
              value={filterStatus}
              onChange={(e) => {
                setFilterStatus(e.target.value)
                setCurrentPage(1)
              }}
              className='w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
            >
              <option value=''>All Status</option>
              <option value='running'>Running</option>
              <option value='completed'>Completed</option>
              <option value='pending'>Pending</option>
            </select>
          </div>

          {/* Start Date Filter */}
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>
              Start Date
            </label>
            <input
              type='date'
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value)
                setCurrentPage(1)
              }}
              className='w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
            />
          </div>

          {/* End Date Filter */}
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>
              End Date
            </label>
            <input
              type='date'
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value)
                setCurrentPage(1)
              }}
              className='w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
            />
          </div>
        </div>

        {/* Active Filters & Reset */}
        {(searchTerm ||
          filterCourse ||
          filterStatus !== '' ||
          startDate ||
          endDate) && (
          <div className='mt-4 flex flex-wrap items-center gap-2'>
            <span className='text-sm font-medium text-gray-700'>
              Active Filters:
            </span>

            {searchTerm && (
              <span className='inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm'>
                Search: {searchTerm}
                <X
                  size={14}
                  className='cursor-pointer'
                  onClick={() => setSearchTerm('')}
                />
              </span>
            )}

            {filterCourse && (
              <span className='inline-flex items-center gap-1 px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm'>
                Course: {filterCourse}
                <X
                  size={14}
                  className='cursor-pointer'
                  onClick={() => setFilterCourse('')}
                />
              </span>
            )}

            {filterStatus && (
              <span className='inline-flex items-center gap-1 px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm'>
                Status: {filterStatus}
                <X
                  size={14}
                  className='cursor-pointer'
                  onClick={() => setFilterStatus('')}
                />
              </span>
            )}

            {startDate && (
              <span className='inline-flex items-center gap-1 px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm'>
                From: {startDate}
                <X
                  size={14}
                  className='cursor-pointer'
                  onClick={() => setStartDate('')}
                />
              </span>
            )}

            {endDate && (
              <span className='inline-flex items-center gap-1 px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-sm'>
                To: {endDate}
                <X
                  size={14}
                  className='cursor-pointer'
                  onClick={() => setEndDate('')}
                />
              </span>
            )}

            <button
              onClick={handleResetFilters}
              className='ml-2 px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm hover:bg-red-200 transition'
            >
              Reset All
            </button>
          </div>
        )}

        {/* Results Count & Total Paid */}
        <div className='mt-4 flex flex-col sm:flex-row justify-between gap-2 text-sm text-gray-600'>
          <div>
            Showing {filteredFees.length} of {fees.length} total records
          </div>
          <div className='font-semibold text-green-700'>
            Total Fee Received (In selected range): ₹{totalPaidFee}
          </div>
        </div>
      </div>

      {/* Fee Cards */}
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6'>
        {currentFees.map((fee) => (
          <div
            key={fee.id}
            className='bg-white rounded-lg shadow-sm p-5 hover:shadow-md transition'
          >
            <div className='flex justify-between items-start mb-3'>
              <div>
                <h3 className='text-lg font-semibold text-gray-800'>
                  {fee.name}
                </h3>
                <p className='text-sm text-gray-500'>{fee.enrollment_number}</p>
              </div>
              <span
                className={`px-3 py-1 rounded-full text-xs font-medium ${
                  fee.status === 'running'
                    ? 'bg-green-100 text-green-700'
                    : 'bg-gray-100 text-gray-700'
                }`}
              >
                {fee.status}
              </span>
            </div>

            <div className='space-y-2 mb-3'>
              <div className='flex justify-between text-sm'>
                <span className='text-gray-600'>Father Name:</span>
                <span className='font-medium'>{fee.father_name}</span>
              </div>
              <div className='flex justify-between text-sm'>
                <span className='text-gray-600'>Course:</span>
                <span className='font-medium'>{fee.course}</span>
              </div>
              <div className='flex justify-between text-sm'>
                <span className='text-gray-600'>Class:</span>
                <span className='font-medium'>{fee.class}</span>
              </div>
              <div className='flex justify-between text-sm'>
                <span className='text-gray-600'>Total Fee:</span>
                <span className='font-medium'>₹{fee.total_fee}</span>
              </div>
              <div className='flex justify-between text-sm'>
                <span className='text-gray-600'>Amount Paid:</span>
                <span className='font-medium text-green-600'>
                  ₹{fee.amount}
                </span>
              </div>
              <div className='flex justify-between text-sm'>
                <span className='text-gray-600'>Due Fee:</span>
                <span className='font-medium text-red-600'>₹{fee.due_fee}</span>
              </div>
              <div className='flex justify-between text-sm'>
                <span className='text-gray-600'>Submit By:</span>
                <span className='font-medium text-blue-500'>
                  {fee.submitted_by_name}
                </span>
              </div>
            </div>

            <div className='border-t pt-3 space-y-1'>
              <div className='flex justify-between text-xs text-gray-500'>
                <span>Submit Date:</span>
                <span>
                  {fee.fee_submit_date && fee.fee_submit_date !== '0001-01-01'
                    ? formatDate(fee.fee_submit_date)
                    : 'N/A'}
                </span>
              </div>
              <div className='flex justify-between text-xs text-gray-500'>
                <span>Payment Mode:</span>
                <span>{fee.payment_mode}</span>
              </div>
              <div className='flex justify-between text-xs text-gray-500'>
                <span>Receipt ID:</span>
                <span>{fee.receipt_id}</span>
              </div>
              <div className='flex justify-between text-xs text-gray-500'>
                <span>Phone:</span>
                <span>{fee.phone_number}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className='bg-white rounded-lg shadow-sm p-4'>
          <div className='flex flex-col sm:flex-row justify-between items-center gap-4'>
            <div className='flex items-center gap-3'>
              <p className='text-sm text-gray-600'>
                Showing {startIndex + 1} to{' '}
                {Math.min(endIndex, filteredFees.length)} of{' '}
                {filteredFees.length} entries
              </p>

              <div className='flex items-center gap-2'>
                <label className='text-sm text-gray-600'>Show:</label>
                <select
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(Number(e.target.value))
                    setCurrentPage(1)
                  }}
                  className='px-3 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500'
                >
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={150}>150</option>
                  <option value={200}>200</option>
                  <option value={300}>300</option>
                  <option value={400}>400</option>
                </select>
              </div>
            </div>

            <div className='flex gap-2'>
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className='px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed'
              >
                Previous
              </button>

              <div className='flex gap-1'>
                {[...Array(totalPages)].map((_, i) => {
                  const pageNum = i + 1
                  if (
                    pageNum === 1 ||
                    pageNum === totalPages ||
                    (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
                  ) {
                    return (
                      <button
                        key={pageNum}
                        onClick={() => setCurrentPage(pageNum)}
                        className={`px-3 py-2 rounded-lg ${
                          currentPage === pageNum
                            ? 'bg-blue-600 text-white'
                            : 'border hover:bg-gray-50'
                        }`}
                      >
                        {pageNum}
                      </button>
                    )
                  } else if (
                    pageNum === currentPage - 2 ||
                    pageNum === currentPage + 2
                  ) {
                    return (
                      <span key={pageNum} className='px-2 py-2'>
                        ...
                      </span>
                    )
                  }
                  return null
                })}
              </div>

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className='px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed'
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}

      {filteredFees.length === 0 && (
        <div className='bg-white rounded-lg shadow-sm p-8 text-center'>
          <p className='text-gray-500'>
            No fee records found for the selected criteria
          </p>
        </div>
      )}
    </div>
  )
}

export default Fee
